var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('a',{attrs:{"href":'/en/media/?sha1=' + _vm.result}},[_vm._v("Search with "+_vm._s(_vm.result))])]),_c('hr'),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }